module.exports = __webpack_public_path__ + "img/product-reviews-02.eab112b3.png";